// Terms and Policies in the footer is a details element, which opens and closes
// by click, tap, Enter and Space on its own. This adds the two things it does
// not do: Escape closes it and hands the focus back to its summary, and the
// summary carries aria-expanded, true to the state, for a reader that does not
// announce a details element's own.
for (const box of document.querySelectorAll('[data-footer-policies]')) {
  const toggle = box.querySelector('summary');
  if (!toggle) continue;

  const sync = () => toggle.setAttribute('aria-expanded', String(box.open));
  sync();
  box.addEventListener('toggle', sync);

  box.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !box.open) return;
    box.open = false;
    toggle.focus();
  });
}
